import Paper from "@mui/material/Paper"
import { styled } from "@mui/material/styles"

import { MAX_PAGE_HEIGHT } from "../utils"

export default styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: MAX_PAGE_HEIGHT.desktop,
  overflowY: "auto",
  [theme.breakpoints.only("xs")]: {
    height: "initial",
    overflowY: "visible",
  },
}))
